import { HomepageContent } from '@/app/(site)/(home)/v2/lib/fetch-content';
import ExperienceCard from '@/components/cards/experience-card/experience-card';
import { ExperienceCardFieldsFragment } from '@/generated/graphql';
import { sanityImageUrlFor } from '@/content/sanity/sanity-image-url-for/sanity-image-url-for';
import styled from '@emotion/styled';
import { Typography } from '@mui/material';

const MainDiv = styled.div`
  width: 100%;
  height: auto;
  margin: 0;
  z-index: 1;
  margin-bottom: 100px;
  padding-left: 10%;
  padding-right: 10%;
  @media (max-width: 768px) {
    padding: 24px 0 0 0;
    padding-bottom: 150px;
    margin-bottom: 150px;
  }
`;

const Title = styled(Typography)`
  margin-bottom: 32px;
  font-family: var(--font-work-sans);
  font-weight: 500;
  font-size: 22px;
  line-height: 127.3%;
  color: #251628;
  position: relative;
  z-index: 9;
`;

const ResultsDiv = styled.div`
  width: 100%;
  height: auto;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-auto-rows: 1fr;
  gap: 32px;
  row-gap: 64px;
  position: relative;
  z-index: 2;
  @media (min-width: 1440px) {
    grid-template-columns: repeat(4, 1fr);
  }
  @media (min-width: 1920px) {
    grid-template-columns: repeat(5, 1fr);
  }
  @media (max-width: 768px) {
    padding: 0;
    row-gap: 0;
    grid-template-columns: repeat(1, 1fr);
    width: max-content;
  }
`;

const ResultCard = styled.div`
  height: 323px;
  max-width: 290px;
  flex: 30%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  @media (max-width: 768px) {
    width: 100%;
    height: auto;
    min-width: 100%;
    max-width: 350px;
    margin-bottom: 32px;
  }
`;

interface ArchiveFeaturedExperiencesProps {
  homepageContent?: HomepageContent;
}

const toExperienceCard = (
  experience: HomepageContent['featuredPastExperiences'][number],
): ExperienceCardFieldsFragment => {
  const imageUrl = experience.mainImage
    ? sanityImageUrlFor(experience.mainImage).width(800).height(800).url()
    : undefined;

  return {
    id: experience._key,
    title: experience.title,
    category: experience.category,
    host: {
      profile: {
        nickname: experience.host,
      },
    },
    images: {
      edges: imageUrl ? [{ node: { file: { url: imageUrl } } }] : [],
    },
  } as unknown as ExperienceCardFieldsFragment;
};

const ArchiveFeaturedExperiences = ({ homepageContent }: ArchiveFeaturedExperiencesProps) => {
  const featuredPastExperiences = homepageContent?.featuredPastExperiences || [];

  if (!featuredPastExperiences.length) {
    return null;
  }

  return (
    <MainDiv>
      <Title>{featuredPastExperiences.length} featured past experiences</Title>
      <ResultsDiv>
        {featuredPastExperiences.map(experience => (
          <ResultCard key={experience._key}>
            <ExperienceCard
              experience={toExperienceCard(experience)}
              noCarousel
              link={`/explore/${encodeURIComponent(experience._key)}`}
            />
          </ResultCard>
        ))}
      </ResultsDiv>
    </MainDiv>
  );
};

export default ArchiveFeaturedExperiences;
